import { Component, defineComponent } from '@decify/cell-shopify/client';
import './QuantitySelector.scss';
export const quantitySelectorName = 'QuantitySelector';
export const quantitySelectorTagName = 'cell-component-quantity-selector';
export const quantitySelectorChangeEvent = 'change';
export class QuantitySelector extends Component {
    elements;
    constructor() {
        super(quantitySelectorName);
        const inputElement = this.querySelector('input');
        if (!inputElement) {
            throw new Error('Input element not found');
        }
        const decrementButtonElement = this.querySelector('button[data-action="decrement"]');
        if (!decrementButtonElement) {
            throw new Error('Decrement button not found');
        }
        const incrementButtonElement = this.querySelector('button[data-action="increment"]');
        if (!incrementButtonElement) {
            throw new Error('Increment button not found');
        }
        this.elements = {
            input: inputElement,
            decrementButton: decrementButtonElement,
            incrementButton: incrementButtonElement,
        };
        this.validateProps(['value']);
        this.handleDecrement = this.handleDecrement.bind(this);
        this.handleIncrement = this.handleIncrement.bind(this);
    }
    componentDidMount() {
        this.elements.decrementButton.subscribe('click', this.handleDecrement);
        this.elements.incrementButton.subscribe('click', this.handleIncrement);
    }
    handleDecrement() {
        const newValue = this.quantity - 1;
        this.elements.input.value = String(newValue);
        this.handleChange();
    }
    handleIncrement() {
        this.elements.input.value = String(this.quantity + 1);
        this.handleChange();
    }
    handleChange() {
        if (this.quantity <= this.minQuantity) {
            this.elements.decrementButton.setAttribute('disabled', '');
        }
        else {
            this.elements.decrementButton.removeAttribute('disabled');
        }
        this.publish(quantitySelectorChangeEvent, {
            quantity: this.quantity,
        });
    }
    reset() {
        this.elements.input.value = String(this.props.value);
    }
    get minQuantity() {
        return Number(this.elements.input.min);
    }
    get quantity() {
        return Number(this.elements.input.value);
    }
}
defineComponent(quantitySelectorTagName, QuantitySelector);
